import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ViewGenericAccountTabContainer = styled.div`
  .basic-details {
    margin: 16px 0;
  }
  .details-container,
  .configuration-container {
    padding: 24px 16px;

    ${responsive.MOBILE`
      padding: 8px;
    `}
  }
  .separator-space-vertical {
    width: 2px;
    height: 32px;
    margin: 10px;
    background-color: ${COLORS.cirrus_black4};
  }
`;
